// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"841":"f8a57267","1227":"f8a57267","2199":"f8a57267","2464":"7aaf09fe","3488":"f8a57267","5281":"7ac6a1a1","6327":"f8a57267","8206":"20824e1c","9407":"f8a57267","9920":"f8a57267"}[chunkId] + ".chunk.css";
};